var map = {
	"./00_post_trade_order_test.json": "CwX9",
	"./01_post_trade_order.json": "vDBD",
	"./01_post_trade_order_vst.json": "6dPc",
	"./02_post_edit_order.json": "vwLZ",
	"./02_post_trade_batch_order.json": "Crrt",
	"./03_post_closeAllPositions.json": "pKuc",
	"./04_delete_trade_order.json": "9V8o",
	"./05_delete_trade_batch_order.json": "hIfT",
	"./06_delete_trade_all_order.json": "Nw8z",
	"./07_get_all_openOrders.json": "Ewmn",
	"./08_check_pending_order.json": "26Si",
	"./08_get_trade_order.json": "/1k/",
	"./09_get_trade_marginType.json": "7mzI",
	"./10_post_trade_marginType.json": "WVbz",
	"./11_get_trade_leverage.json": "/Kh3",
	"./12_post_trade_leverage.json": "ZoHP",
	"./13_get_trade_forceOrders.json": "9bR8",
	"./14_get_trade_allOrders.json": "7bgg",
	"./15_post_trade_positionMargin.json": "QHIT",
	"./17_get_trade_allFillOrders.json": "7iFh",
	"./18_set_positionSide.json": "QEfH",
	"./19_get_positionSide.json": "jzOs",
	"./20_cancel_replace_order.json": "4bTX",
	"./21_batch_cancel_replace_order.json": "/nLp",
	"./22_cancel_all_after.json": "1pQ9",
	"./22_post_closePosition.json": "/qZT",
	"./23_get_trade_allOrdersV2.json": "iRbd",
	"./24_get_maint_margin_ratio.json": "OyBm",
	"./25_get_fill_history_detail.json": "PJcf",
	"./26_get_user_position_history.json": "sWA2",
	"./27_get_position_margin_history.json": "5iQm",
	"./27_post_get_vst.json": "dtEQ",
	"./28_post_twap_order.json": "50Mv",
	"./29_get_twap_open_orders.json": "0L6n",
	"./30_get_twap_history_orders.json": "srGS",
	"./31_get_twap_order_detail.json": "+xXY",
	"./32_cancel_twap_order.json": "5pjb",
	"./33_post_asset_mode.json": "thBV",
	"./34_get_asset_mode.json": "cRAY",
	"./35_get_multi_asset_rule.json": "EWHP",
	"./36_get_margin_asset.json": "/HCz",
	"./37_post_trade_reverse.json": "NBWN",
	"./38_post_auto_add_margin.json": "FDO9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Rqf2";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/api/trade \.json$
// module id = Rqf2
// module chunks = 3